module.exports = __webpack_public_path__ + "img/palutena-min.8a0d904d.png";